import { profileman, profilemadame } from '../../img/profile';
import { createContext, useContext } from "react";
import { ContextSession } from '../../services/ContextSession';
import './fichadni.component.css';
//0701-1997-00363
export default function FichaDni({ dniData, nacimiento }) {
  const { sessionData } = useContext(ContextSession);
  const { nombre, apellido, username } = sessionData;
  // Modificar el formato de la fecha de nacimiento
  function formatData(fechadenacimiento) {
    if (fechadenacimiento != undefined) {
      return fechadenacimiento.substring(0, 10);
    }
    else {
      return console.log('No se encontro fecha');
    }
  }

  return (
    <>
      {
        dniData != undefined && (
          <div className="ficha">
            <div className="imagen">
              {/* Imagen con marca de agua */}
              <div className="watermark-container">
                <div className="image-overlay"></div> {/* Elemento superpuesto */}
                <img
                  src={dniData.foto != null ? 'data:image/png;base64,' + dniData.foto : dniData.sexo == "M" ? profileman : profilemadame}
                  alt="Foto"
                />
                <div className="watermark" style={{ textAlign: "center" }}>
                  Usuario: {username} <br />
                  {nombre} {apellido} <br />
                  INJUPEMP
                </div>
              </div>
            </div>
            <div className="datos-container">
              <div className="datos">
                <div className="seccion">
                  <h2>Datos Personales</h2>
                  <table>
                    <tbody>
                      <tr>
                        <td className="etiqueta1">Identidad:</td>
                        <td className="valor1">{dniData.numinscripcion}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Nombres:</td>
                        <td className="valor">{dniData.nombres}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Apellidos:</td>
                        <td className="valor1">{dniData.primerapellido} {dniData.segundoapellido}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Sexo:</td>
                        <td className="valor">{dniData.sexo}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Fecha Nacimiento:</td>
                        <td className="valor1">{formatData(dniData.fechadenacimiento)}
                        </td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Estado Civil:</td>
                        <td className="valor">{dniData.descrestadocivil}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Estado Vivencia:</td>
                        <td className="valor1">{dniData.descrestadovivencia}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Teléfono:</td>
                        <td className="valor">{dniData.numerotelefono}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Celular:</td>
                        <td className="valor1">{dniData.telefonocelular}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="seccion">
                  <h2>Datos de Residencia Y Ocupación</h2>
                  <table>
                    <tbody>
                      <tr>
                        <td className="etiqueta">Pais Nacimiento:</td>
                        <td className="valor">{dniData.descrpaisnacimiento}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Pais Residencia:</td>
                        <td className="valor1">{dniData.descrpaisresidencia}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Departamento:</td>
                        <td className="valor">{dniData.descrdeptonacimiento}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Municipio:</td>
                        <td className="valor1">{dniData.descrmunicnacimiento}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Departamento Residencia:</td>
                        <td className="valor">{dniData.descrdeptoresidencia}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Municipio Residencia:</td>
                        <td className="valor1">{dniData.descrmunicresidencia}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Barrio Residencia:</td>
                        <td className="valor">{dniData.descrbarrioresidencia}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta1">Direccion Residencia:</td>
                        <td className="valor1">{dniData.direccionresidencia}</td>
                      </tr>
                      <tr>
                        <td className="etiqueta">Ocupación Laboral:</td>
                        <td className="valor">{dniData.descrocupacionlaboral}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/*<img className="background-image" src="/img/black.png" alt="Background Image" />*/}
            </div>
          </div>
        )
      }
      {
        dniData.error != undefined && (

          <div className="ficha">
            <div className="datos-container">
              <div className="datos">
                <div className="seccion">
                  <h2>Consultas</h2>
                  <table>
                    <tbody>
                      <tr>
                        <td className="valor1" align='center'>No se encontraron datos para ese número de identidad.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )

      }
    </>
  );
}

